<div class="choose-type">
  <div class="header d-flex justify-content-start align-items-center">
    <h3 class="fontsize22">1. {{ 'view_translations.choose_type' | translate }}</h3>
    <button *ngIf="currentMode === 'chosen'" type="button" class="global-transition traffic-source-button fontsize14" (click)="onChangeType()">
      <span class="button-text"
        ><nb-icon icon="edit" pack="icomoon"></nb-icon><span class="fontsize14 font500">{{ 'view_translations.change' | translate }}</span></span
      >
    </button>
  </div>
  <div *ngIf="currentMode === 'chooseType'" class="label-container-wrapper">
    <div class="row no-gutters">
      <div *ngFor="let type of modalConfig" class="col-12 col-sm-6 col-md-4 no-gutters d-flex justify-content-center">
        <app-label-container (selectedSource)="onSelectSource($event)" [id]="type.id ?? 0"> </app-label-container>
      </div>
    </div>
    <a class="link-to-video" href="https://youtu.be/uoRT4kdlzh8?si=-gu4-VgnQ83YFPeK" target="_blank">
      <div class="show-video-container">
        <p>{{ 'view_translations.link_adding_traffic_source' | translate }}</p>
        <nb-icon pack="icomoon" icon="external-link-bold"></nb-icon>
      </div>
    </a>
  </div>
  <div *ngIf="currentMode === 'chosen'" class="label-container-wrapper">
    <div class="row no-gutters">
      <div class="col-12 col-sm-4 no-gutters d-flex justify-content-center">
        <app-label-container [id]="selectedType?.id ?? 0" [active]="true"> </app-label-container>
      </div>
    </div>
  </div>
</div>
